import _extends from "@babel/runtime/helpers/extends";
import Tooltip from '@atlaskit/tooltip';
import React from 'react';
import ActionButton from './action-button';
const ActionStackItem = ({
  content,
  tooltipMessage,
  tooltipOnHide,
  hideTooltipOnMouseDown,
  hideTooltip,
  ...props
}) => hideTooltip ? /*#__PURE__*/React.createElement(ActionButton, _extends({}, props, {
  content: content
})) : /*#__PURE__*/React.createElement(Tooltip, {
  content: tooltipMessage || content,
  onHide: tooltipOnHide,
  hideTooltipOnMouseDown: hideTooltipOnMouseDown
}, tooltipProps => /*#__PURE__*/React.createElement(ActionButton, _extends({}, props, {
  content: content,
  tooltipProps: tooltipProps
})));
export default ActionStackItem;